import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const contentSlice = createAppSlice({
  name: 'content',
  initialState,
  reducers,
});

export const {
  loadProducts,
  deleteProduct,
  promoteProduct,
  updateProduct,
  loadDocuments,
  loadPendingDownloads,
  loadRecordings,
  loadUploadedVideos,
  setViewType,
  setSearch,
  setSortBy,
  setPageNumber,
  exitEditing,
  updateContentMarkedForDeletion,
  setSelectedFileType,
  setContentTypeToAdd,
  setProjectsFilter,
  setProductAttributesFilter,
  createUploadJob,
  updateUploadJob,
  finishUploadJob,
  clearUploadedVideos,
  clearRecordings,
  clearUploadJobs,
  loadTemplates,
  loadFonts,
  loadThemePacks,
  deleteDocuments,
  deleteRecording,
  deleteUploadedVideo,
  deleteThemePack,
} = contentSlice.actions;

export default contentSlice.reducer;
